<template>
    <div :class="{'item__checkbox-radio-container': filterColumn, 'item__checkbox-radio-container2': !filterColumn}">
        <div class="checkbox-radio" v-for="(option, index) in options" :key="option.key" @click="change(option.key)" v-show="(index <= 4) || showAll">
            <div class="checkbox" :class="{'checked': modelValue[option.key] !== undefined}">
                <i class="termi-circle-checkmark"></i>
            </div>
            {{option.value}}
        </div>
        <div class="checkbox-radio-showAll"
             :class="{'checkbox-radio-showAll--open' : showAll}"
             v-if="options && options.length > 4"
             @click="showAll = !showAll"
        >
            {{showAll ? 'Скрыть' : 'Показать все'}}
            <i class="termi-chevron-right"></i>
        </div>
    </div>
</template>

<script>
import v_multiselect from '@/components/multiselect.vue'
export default {
    components: {v_multiselect},
    props: ['modelValue', 'options', 'filterColumn', 'prop'],
    emits: ['update:modelValue'],
    data() {
        return {
            v: [],
            r: 0,
            list: [],
            MultiSelectEnabled: false,
            showAll: false,
        }
    },
    mounted: async function(){
        await this.$nextTick();
        this.r = Math.floor(Math.random() * (1000000));
        let strokeCount = this.filterColumn ? this.options.length / 2 : this.options.length;
        if(strokeCount > 6){
            this.MultiSelectEnabled = true;
            for(let index in this.options){
                let opt = this.options[index];
                this.list.push({name: opt.value, key: opt.key})
                for(let current in this.modelValue) {
                    if(parseInt(this.modelValue[current].value) === opt.key){
                        this.v.push({name: opt.value, key: opt.key})
                    }
                }
            }
        } else{
            for(let current in this.modelValue) {
                this.v.push(this.modelValue[current]['value'])
            }
        }
    },
    methods: {
        change(key) {
            const obj = {...this.modelValue}
            obj[key] === undefined ? obj[key] = key : delete obj[key]
            this.$emit('update:modelValue', obj)
            this.$emit('change')
        }
    }
}
</script>